(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aartaa-trade-page"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll(".aartaa-trade [data-trade-result]").forEach(result=>result.focus());
  } catch(e) { console.error(e); }
})();

})();
